// Slice B2.4-B — window dispatch for structured dock peek events.

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import type { ActivityDockAssistLevel } from "@/lib/activityDock/assistLevel";
import {
  ACTIVITY_DOCK_PEEK_EVENT,
  buildActivityDockPeekEventDetail as buildPeekDetail,
  type ActivityDockPeekEventDetail as PeekEventDetailBase,
} from "@/lib/activityDock/peekEventDetail";

export { ACTIVITY_DOCK_PEEK_EVENT };

/** Client peek payload — mode is always a known primary mode id. */
export type ActivityDockPeekEventDetail = Omit<PeekEventDetailBase, "mode"> & {
  mode: PrimaryMode;
};

export function buildActivityDockPeekEventDetail(input: {
  mode: PrimaryMode;
  reasonSectionId: string;
  assistLevel: ActivityDockAssistLevel;
  nowMs: number;
}): ActivityDockPeekEventDetail {
  return buildPeekDetail({
    mode: input.mode,
    reasonSectionId: input.reasonSectionId,
    assistLevel: input.assistLevel,
    nowMs: input.nowMs,
  }) as ActivityDockPeekEventDetail;
}

export function emitActivityDockPeekEvent(detail: ActivityDockPeekEventDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ActivityDockPeekEventDetail>(ACTIVITY_DOCK_PEEK_EVENT, {
      detail,
    }),
  );
}
